import { Box3, Mesh, Object3D, Vector3 } from "three";

import { computeMorphedAttributes } from "three/examples/jsm/utils/BufferGeometryUtils";

export function computeBoundingBoxHelper(
  obj3D: Object3D,
): IBoundingBoxResult | null {
  if (!obj3D) {
    return null; // --> Fast return
  }

  const size = new Vector3();
  const box = new Box3().setFromObject(obj3D);

  box.getSize(size);

  return {
    size,
    box,
    centroid: new Vector3().addVectors(box.max, box.min).multiplyScalar(0.5),
  };
}

export function computeBoundingBoxMorphedHelper(
  obj3D: Mesh,
): IBoundingBoxResult | null {
  if (!obj3D) {
    return null; // --> Fast return
  }

  const size = new Vector3();

  const morphedGeomData = computeMorphedAttributes(obj3D);

  const box = new Box3().setFromBufferAttribute(
    morphedGeomData.morphedPositionAttribute ||
      morphedGeomData.positionAttribute,
  );

  box.getSize(size);

  return {
    size,
    box,
    centroid: new Vector3().addVectors(box.max, box.min).multiplyScalar(0.5),
  };
}

export interface IBoundingBoxResult {
  size: Vector3;
  box: Box3;
  centroid: Vector3;
}
